import React, { PureComponent } from 'react';
import { Grid, Button } from '@material-ui/core';
import { Document, Page } from 'react-pdf';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import 'react-pdf/dist/Page/AnnotationLayer.css';

import BackButton from '../../components/BackButton';
import PageTitle from '../../components/PageTitle';

import monthName from '../../utils/monthName';

class ShowPaycheck extends PureComponent {
  constructor() {
    super();

    this.state = {
      numPages: null,
      pageNumber: 1,
      width: null,
    };

    this.setPdfSize = this.setPdfSize.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  componentDidMount() {
    this.handleShow();
  }

  componentDidUpdate() {
    if (!isEmpty(this.props.currentPaycheck)) this.setPdfSize();
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  setPdfSize() {
    this.setState({ width: this.pdfWrapper.getBoundingClientRect().width });
  }

  handleShow() {
    const { match: { params }, showPaycheck } = this.props;
    showPaycheck(params.id);
  }

  render() {
    const { pageNumber, width } = this.state;
    const { currentPaycheck: { month, file, year }, currentPaycheck } = this.props;
    return (
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <BackButton history={this.props.history} />
        </Grid>
        <Grid item xs>
          { !isEmpty(currentPaycheck) && <PageTitle> {`Recibo ${monthName(month)} ${year}`} </PageTitle> }
        </Grid>
        <Grid item>
          { !isEmpty(currentPaycheck) &&
            <Button variant="contained" color="primary" href={file} download>
              Descargar
            </Button>
          }
        </Grid>
        { !isEmpty(currentPaycheck) &&
          <Grid id="js-document" item xs={12}>
            <div
              className='w-100'
              ref={(ref) => { this.pdfWrapper = ref; }}
            >
              <Document
                file={file}
                error="Error al cargar el archivo. Presione descargar."
                onLoadSuccess={this.onDocumentLoadSuccess}
              >
                <Page width={width} pageNumber={pageNumber} />
              </Document>
            </div>
          </Grid>
        }
      </Grid>
    );
  }
}

export default ShowPaycheck;

ShowPaycheck.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  showPaycheck: PropTypes.func.isRequired,
  currentPaycheck: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/Paychecks/ShowPaycheck.js